import { render, staticRenderFns } from "./EmployeeSalarySettingAdd.vue?vue&type=template&id=40b8c182&scoped=true&"
import script from "./EmployeeSalarySettingAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalarySettingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b8c182",
  null
  
)

export default component.exports